export default [
  {
    title: 'Portal de documentos',
    route: { name: 'portaldocumentos-externo' },
    icon: '',
    resource: 'portaldocumentosexterno',
    action: 'read',
  },
]
